<template lang="html">

  <section class="banner-mantenimiento">
    <div class="row-between container">
      <div class="contenedor-texto">
        <h2>
          <span class="-orange">Somos</span>
          <span class="-dark">mantenimiento</span>
        </h2>

        <h4 class="-dark">Consulta los servicios de mantenimiento que tenemos disponibles para nuestras tarifas de luz y
          gas.</h4>
        <router-link class="btn -degree" :to="$t('enlaces.ofrecemosMuchoMas')" title="Enlace a simulador"
          aria-label="Enlace a simulador">Ver servicios</router-link>
      </div>
      <img class="img-decor" src="/static/img/mantenimiento.webp" alt="Imagen de mantenimiento">


    </div>

  </section>

</template>

<script lang="js">
export default {
  name: 'banner-somos-ahorro'
}
</script>

<style scoped lang="scss">
.banner-mantenimiento .container {
  padding: 0 50px;
  max-width: 1270px;
}

.contenedor-texto {
  width: calc(100% - 525px);
  text-align: left;
  position: relative;
  z-index: 2;

  p {
    margin: 10px 0;

    &:last-of-type {
      margin-top: 0;
    }
  }


  .btn {
    margin-top: 30px;
  }

}

.img-decor {
  max-width: 525px;
  width: 100%;

}


@media screen and (max-width: 950px) {

  .contenedor-texto {
    width: 100%;
  }
}

@media screen and (max-width: 830px) {
  .container {
    justify-content: flex-start;
  }
}


@media screen and (max-width: 630px) {

  .contenedor-texto {
    max-width: 100%;
  }

  .container {
    padding-bottom: 20vw;
  }

}

@media screen and (max-width: 600px) {

  .container {
    padding-bottom: 50px;
    padding-left: 15px;
    padding-right: 15px;
    justify-content: center;
    -webkit-justify-content: center;
  }

  .contenedor-texto {
    max-width: 350px;
    text-align: center;

    * {
      text-align: left;
    }
  }

  .contenedor-texto .btn {
    margin-top: 10px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/parts/banner-mantenimiento.vue